/* Tren navideño (tn-*): galería, botones de pago y barra fija. */
(function () {
  function listo(f) {
    if (document.readyState !== 'loading') f();
    else document.addEventListener('DOMContentLoaded', f);
  }

  function buscarBotonPago() {
    var selectores = [
      '#rsi-button-hook button',
      '#rsi-button-hook a',
      '._rsi-buy-now-button-app-block-hook button',
      '._rsi-buy-now-button-app-block-hook a',
      'button[id^="rsi"]',
      'button[class*="rsi-"]'
    ];
    for (var i = 0; i < selectores.length; i++) {
      var el = document.querySelector(selectores[i]);
      if (el) return el;
    }
    return null;
  }

  listo(function () {
    /* Galería: al tocar una miniatura se cambia la foto grande */
    document.querySelectorAll('[data-tn-gal]').forEach(function (gal) {
      var grande = gal.querySelector('[data-tn-main]');
      var minis = gal.querySelectorAll('[data-tn-thumb]');
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!grande) return;
          grande.src = mini.getAttribute('data-src');
          grande.removeAttribute('srcset');
          minis.forEach(function (m) { m.classList.remove('is-on'); });
          mini.classList.add('is-on');
        });
      });
    });

    /* Ofertas: al elegir una tarjeta solo se resalta; la cantidad la decide la oferta marcada dentro de Releasit */
    document.querySelectorAll('[data-tn-ofertas]').forEach(function (grupo) {
      grupo.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          grupo.querySelectorAll('[data-tn-of]').forEach(function (t) {
            t.classList.toggle('is-on', t.contains(radio));
          });
        });
      });
    });

    /* Al abrir el formulario de Releasit, marcar en él la oferta elegida en la página */
    var cantidadElegida = function () {
      var marcada = document.querySelector('[data-tn-ofertas] input[type="radio"]:checked');
      return marcada ? Number(marcada.value) : 0;
    };
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('#rsi-button-hook, ._rsi-buy-now-button-app-block-hook, [data-tn-pay]')) return;
      var cantidad = cantidadElegida();
      if (!cantidad) return;
      var intentos = 0;
      var aplicar = function (veces) {
        var ofertas = document.querySelectorAll('label.rsi-quantity-product');
        var radio = ofertas[cantidad - 1] && ofertas[cantidad - 1].querySelector('input[type="radio"]');
        if (!radio) return;
        var otras = false;
        ofertas.forEach(function (o, i) {
          var r = o.querySelector('input[type="radio"]');
          if (i !== cantidad - 1 && r && r.checked) otras = true;
        });
        if (radio.checked && !otras) return;
        radio.click();
        if (veces < 4) setTimeout(function () { aplicar(veces + 1); }, 900);
      };
      var buscar = setInterval(function () {
        intentos++;
        var ofertas = document.querySelectorAll('label.rsi-quantity-product');
        if (ofertas.length >= cantidad) {
          clearInterval(buscar);
          /* Releasit termina de pintar y de marcar su oferta inicial; se espera antes de cambiarla */
          setTimeout(function () { aplicar(0); }, 1200);
        } else if (intentos > 30) {
          clearInterval(buscar);
        }
      }, 150);
    }, true);

    /* Botones "pagar contra entrega": abren el botón de Releasit o llevan hasta él */
    document.querySelectorAll('[data-tn-pay]').forEach(function (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        var real = buscarBotonPago();
        if (real) {
          real.scrollIntoView({ block: 'center', behavior: 'smooth' });
          setTimeout(function () { real.click(); }, 350);
        } else {
          var gancho = document.getElementById('rsi-button-hook');
          if (gancho) gancho.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
    });

    /* Barra fija: aparece cuando el botón principal ya no se ve */
    var barra = document.querySelector('[data-tn-fijo]');
    var referencia = document.getElementById('rsi-button-hook') || document.querySelector('[data-tn-compra]');
    if (barra && referencia) {
      var revisar = function () {
        var r = referencia.getBoundingClientRect();
        var visible = r.top < window.innerHeight && r.bottom > 0;
        barra.classList.toggle('is-on', !visible && window.scrollY > 200);
      };
      window.addEventListener('scroll', revisar, { passive: true });
      window.addEventListener('resize', revisar);
      revisar();
    }
  });
})();
